import type {
  ModifiedPlayer,
  NFLPlayerInputs
} from '@library/types/simulations';
import { useEffect, useMemo, useState } from 'react';
import { Checkbox } from '@library/components/inputs';
import type { LeagueTeamPlayer } from '@library/types/player';

export const BooleanOverride = ({
  field,
  homeTeam,
  modifiedPlayer = undefined,
  onModifyPlayer,
  player
}: {
  field: keyof NFLPlayerInputs;
  homeTeam: boolean;
  modifiedPlayer?: ModifiedPlayer;
  onModifyPlayer: ({
    homeTeam,
    playerId,
    playerName,
    value
  }: {
    homeTeam: boolean;
    playerId: string;
    playerName: string;
    value: Partial<NFLPlayerInputs>;
  }) => void;
  player: LeagueTeamPlayer;
}) => {
  const [checkboxChecked, setCheckboxChecked] = useState<boolean | undefined>(
    () => {
      const modifiedPlayerField = modifiedPlayer?.playerOverrides[field];

      return modifiedPlayerField !== undefined
        ? (modifiedPlayerField as boolean)
        : undefined;
    }
  );

  const handleToggleBoolean = useMemo(
    () =>
      ({ value }: { value: boolean }) => {
        onModifyPlayer({
          playerId: player.foreign_id,
          playerName: player.name,
          value: { [field]: value },
          homeTeam
        });
      },
    [field, homeTeam, onModifyPlayer, player.foreign_id, player.name]
  );

  useEffect(() => {
    if (
      checkboxChecked !== undefined &&
      (modifiedPlayer?.playerOverrides[field] !== checkboxChecked ||
        !modifiedPlayer)
    ) {
      handleToggleBoolean({ value: checkboxChecked });
    }
  }, [checkboxChecked, field, handleToggleBoolean, modifiedPlayer]);

  return (
    <Checkbox
      checked={checkboxChecked}
      id={`${field}-${player.foreign_id}`}
      onCheckboxChange={({ checked }) => {
        setCheckboxChecked(checked);
      }}
    />
  );
};
